// extracted by mini-css-extract-plugin
export default {"page":"Page_page__-iz7A","active":"Page_active__p8Y+0","title":"Page_title__tkOs4","content":"Page_content__FjbNA"};